import React from "react";

const Footer = ({landingPageData}) => {
  return (
    <div>
      <div className=" mx-auto lg:px-28 lg:mt-90 p-8">
        <div className="flex flex-col justify-center items-center">
          {/* heading */}
          <div>
            <h2 className="text-30 font-bold text-center">
              {landingPageData.footerSection.title1}
            </h2>
          </div>

          <div className="text-12 lg:text-14 font-[400] bg-chipYellow rounded-full max-w-300 flex justify-center px-6 py-2 text-yellow mt-4">
            <h1>
              {landingPageData.footerSection.title2}
            </h1>
          </div>

          {/* Category Section */}
          <div className="flex flex-col justify-center items-center mt-10">
            <h1 className="text-18 text-textBlack max-w-810 text-center">
              {landingPageData.footerSection.description}
            </h1>

            <a
              href={landingPageData.footerSection.btnLink}
              className="mt-14 bg-blue text-white py-3 px-6 rounded-md flex justify-center items-center cursor-pointer"
            >
                {landingPageData.footerSection.btnText}
            </a>

            <h1 className="text-16 text-textBlack max-w-810 text-center mt-6 mb-14">
              Already a Partner? {" "}
              <a href={landingPageData.footerSection.textLink} className="text-blue cursor-pointer">
              Login
              </a>
            </h1>
          </div>
        </div>

      </div>
      <div className="bg-footerBg min-h-50"></div>

    </div>
  );
};

export default Footer;
